import React, { useState, useEffect } from "react";
import { useFormik } from "formik";
import { notificationSchema } from "../../../Validations/notificationsValidation";
import { sendNotications } from "../../../apis/notificationApi";
import { uploadImageServer } from "../../../apis/ImageApi";
import TextInputFormik from "../../../lib/common/TextInputFormik";

export default function AddNotifications({ expoToken, onClose, resetKey }) {
  const [loading, setLoading] = useState(false);
  const [detail, setDetail] = useState(false);
  const [success, setSuccess] = useState(false);
  const categoriesList = [
    "DetailsStack Team",
    "MapStack Team",
    "ProfileStack Team",
    "Upcoming Events",
    "Feature updates",
  ];
  const uploadFile = async (e) => {
    const file = e.target.files[0];
    const formData = new FormData();
    formData.append("file", file);
    const path = await uploadImageServer(formData);
    if (path) {
      formik.setFieldValue("image", path.path);
    }
  };
  useEffect(() => {
    formik.resetForm();
    formik.setFieldValue("category", "");
    setSuccess(false);
  }, [resetKey]);

  const formik = useFormik({
    initialValues: {
      expoPushToken: expoToken || "",
      category: "",
      title: "",
      body: "",
      email: "",
      image: "",
      linking: "",
      screen: "",
      itemId: "",
      manual: true,
      germanTitle: "",
      germanBody: "",
    },
    validationSchema: notificationSchema,
    onSubmit: async (values) => {
      try {
        setLoading(true);
        const payload = {
          category: values.category || "",
          email: values.email || "",
          image: values.image || "",
          linking: values.linking || "",
          screen: values.screen || "",
          itemId: values.itemId || "",
          manual: true,
          en: {
            title: values.title || "",
            body: values.body || "",
          },
          de: {
            title: values.germanTitle || "",
            body: values.germanBody || "",
          },
        };
        const res = await sendNotications(payload);
        console.log(res);
        setLoading(false);
        formik.resetForm();
        setSuccess(true);
        // onClose() // Close the modal after successful submission
      } catch (error) {
        console.error("Error submitting form:", error);
        setLoading(false);
      }
    },
  });

  return (
    <>
      {success ? (
        <div>
          <h5 className="text-success  h5 mt-4 " id="successModalLabel">
            Success
          </h5>

          <div className="mt-3 d-flex">
            <button
              type="button"
              className="btn btn-primary"
              onClick={() => {
                onClose();
                setSuccess(false);
              }}
            >
              <span aria-hidden="true">Close</span>
            </button>
          </div>
        </div>
      ) : (
        <form onSubmit={formik.handleSubmit}>
          {/* <div className="mb-3">
        <label className="form-label">Expo Token</label>
        <input
          className="form-control"
          type="text"
          name="expoPushToken"
          value={formik.values.expoPushToken}
          readOnly
        />
      </div> */}
          <div className="mb-3">
            <label className="form-label">Category</label>
            <select
              name="category"
              onChange={formik.handleChange}
              className="form-control"
              placeholder="Select Category"
            >
              <option value="">Select Category</option>
              {categoriesList.map((cat, i) => (
                <option value={cat} key={i}>
                  {cat}
                </option>
              ))}
            </select>
            {formik.touched.category && formik.errors.category && (
              <div className="text-danger">{formik.errors.category}</div>
            )}
          </div>
          {formik.values.category != "" && (
            <>
              <TextInputFormik
                label="Notification Title"
                field="title"
                placeholder="Enter the notification Title"
                formik={formik}
              />

              <div className="mb-3">
                <label className="form-label">Message</label>
                <textarea
                  className="form-control"
                  type="text"
                  placeholder="Enter the notification Message"
                  name="body"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                >
                  {formik.values.body}
                </textarea>
                {formik.touched.body && formik.errors.body && (
                  <div className="text-danger">{formik.errors.body}</div>
                )}
              </div>
              <div className="mb-3">
                <label className="form-label">German Notification Title</label>
                <input
                  className="form-control"
                  type="text"
                  placeholder="Enter the German notification Title"
                  name="germanTitle"
                  value={formik.values.germanTitle}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  // readOnly={true}
                />
                {formik.touched.germanTitle && formik.errors.germanTitle && (
                  <div className="text-danger">{formik.errors.germanTitle}</div>
                )}
              </div>

              <div className="mb-3">
                <label className="form-label">German Message</label>
                <textarea
                  className="form-control"
                  name="germanBody"
                  placeholder="Enter the German notification Message"
                  value={formik.values.germanBody}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  // readOnly={true}
                />
                {formik.touched.germanBody && formik.errors.germanBody && (
                  <div className="text-danger">{formik.errors.germanBody}</div>
                )}
              </div>
              <div className="input-block">
                <label className="form-label">
                  Image (size should be less than 1 mb)
                </label>
                <input
                  className="form-control"
                  type="file"
                  name="image"
                  accept="image/*"
                  onChange={uploadFile}
                  onBlur={formik.handleBlur}
                  placeholder="Upload File"
                  style={{ width: "250px" }}
                />
                {formik.errors.image && formik.touched.image && (
                  <span className="text-danger">{formik.errors.image}</span>
                )}
                {formik.values.image && (
                  <img src={formik.values.image} width={300} />
                )}
              </div>
              {/* <div className="mb-3">
        <label className="form-label">Link</label>
        <input
          className="form-control"
          type="url"
          name="linking"
           placeholder="Enter the notification link"
          value={formik.values.linking}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
        />

        {formik.touched.linking && formik.errors.linking && (
          <div className="text-danger">{formik.errors.linking}</div>
        )}
      </div> */}
              <div>{formik.values.category}</div>
              {["Upcoming Events", "Feature updates"].includes(
                formik.values.category
              ) && (
                <TextInputFormik
                  label="Link"
                  type="url"
                  field="linking"
                  placeholder="Enter the link"
                  formik={formik}
                />
              )}

              {/* {formik.values.category == "Important Dates" && (
                <div>
                  <div className="mb-3">
                    <label className="form-label">Event Title</label>
                    <input
                      className="form-control"
                      type="text"
                      name="eventTitle"
                      placeholder="Enter the Event Title"
                      value={formik.values.eventTitle}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                    />
                    {formik.touched.eventTitle && formik.errors.eventTitle && (
                      <div className="text-danger">
                        {formik.errors.eventTitle}
                      </div>
                    )}
                  </div>

                  <div className="mb-3">
                    <label className="form-label">Start Date</label>
                    <input
                      className={`form-control ${
                        formik.touched.startDate && formik.errors.startDate
                          ? "is-invalid"
                          : ""
                      }`}
                      type="datetime-local"
                      name="startDate"
                      value={formik.values.startDate}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                    />
                    {formik.touched.startDate && formik.errors.startDate && (
                      <div className="text-danger">
                        {formik.errors.startDate}
                      </div>
                    )}
                  </div>

                  <div className="mb-3">
                    <label className="form-label">End Date</label>
                    <input
                      className={`form-control ${
                        formik.touched.endDate && formik.errors.endDate
                          ? "is-invalid"
                          : ""
                      }`}
                      type="datetime-local"
                      name="endDate"
                      value={formik.values.endDate}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                    />
                    {formik.touched.endDate && formik.errors.endDate && (
                      <div className="text-danger">{formik.errors.endDate}</div>
                    )}
                  </div>
                </div>
              )} */}
              <TextInputFormik
                label="Email (To send a single user)"
                field="email"
                placeholder="Enter the Email"
                formik={formik}
                required={false}
              />

              <div className="mb-3">
                <label className="form-label">User Type</label>
                <select
                  className="form-control"
                  name="role" // Changed name to role to reflect the dropdown purpose
                  value={formik.values.role}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                >
                  <option value="">Select User Type</option>{" "}
                  {/* Default select option */}
                  {/* {formik.values.category != "Investment Performance" && (
                  )} */}
                  {/* Both users and brokers */}
                  <option value="all">All</option>
                  <option value="user">User</option>
                  {/* <option value="broker">Broker</option> */}
                </select>
                {formik.touched.role && formik.errors.role && (
                  <div className="text-danger">{formik.errors.role}</div>
                )}
              </div>
              {/* {formik.values.category != "Upcoming Events" && (
                <>
                  <div onClick={() => setDetail(!detail)}>
                    Developer Additional Info {detail ? "-" : "+"}{" "}
                  </div>
                  {detail && (
                    <div>
                      <TextInputFormik
                        label="Screen"
                        field="screen"
                        formik={formik}
                        required={false}
                        placeholder="Enter the ScreenName"
                      />

                      <TextInputFormik
                        label="Item Id"
                        field="itemId"
                        type="number"
                        placeholder="Enter the Item Id"
                        formik={formik}
                      />
                    </div>
                  )}
                </>
              )} */}
              {/* <div className='mb-3'>
            <label className='form-label'>GMO ID</label>
            <input
              className='form-control'
              type='text'
              placeholder='Enter the GMO-Id'
              name='gmoId'
              value={formik.values.gmoId}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
            />
            {formik.touched.gmoId && formik.errors.gmoId && (
              <div className='text-danger'>{formik.errors.gmoId}</div>
            )}
          </div> */}
            </>
          )}
          <div className="d-flex justify-content-end">
            <button
              className="btn btn-secondary me-2"
              type="button"
              onClick={onClose}
            >
              Cancel
            </button>
            <button
              className="btn btn-primary"
              type="submit"
              disabled={loading}
            >
              {loading ? "Sending..." : "Submit"}
            </button>
          </div>
        </form>
      )}
    </>
  );
}
